export default {"theme":{"themes":{"light":{"primary":"#1893db"}}}}
